import React from 'react';
import { useSearchParams } from 'react-router-dom';

import { EmptyTutorial } from '@dashboard/components/empty-states/EmptyTutorial';
import { Link, Typography } from '@mui/material';

export default function EmptyPageTutorial() {
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type');

  if (type === 'LAYOUT') {
    return (
      <EmptyTutorial
        description={
          <>
            <Typography variant="h4" gutterBottom>
              You haven't created a layout yet
            </Typography>
            <Typography color="text.secondary">
              Share headers, footers, and styles across email templates.{' '}
              <Link target="_blank" href="https://www.usewaypoint.com/docs/template-layouts">
                Learn more
              </Link>
              .
            </Typography>
          </>
        }
        videoSource="https://assets.usewaypoint.com/teaser-template-layouts-voiceover.mp4"
        videoTitle="Video teaser of template layouts on Waypoint"
      />
    );
  }

  return (
    <EmptyTutorial
      description={
        <>
          <Typography variant="h4" gutterBottom>
            You haven't created a template yet
          </Typography>
          <Typography color="text.secondary">
            Build data-rich email templates, faster than ever.{' '}
            <Link target="_blank" href="https://www.usewaypoint.com/docs/template-basics">
              Learn more
            </Link>
            .
          </Typography>
        </>
      }
      videoSource="https://assets.usewaypoint.com/teaser-template-builder-voiceover.mp4"
      videoTitle="Video teaser of templates on Waypoint"
    />
  );
}
